






import { Richtext } from 'storyblok-js-client';
import { defineComponent, PropType } from '@vue/composition-api';
import { useStoryblok } from '~/composables/useStoryblok';
import FCFaqCard from '~/components/FCFaqCard.vue';

export interface IFaqCardProps {
  codeId: string;
  question: string;
  answer: Richtext;
}

export default defineComponent({
  name: 'FaqCard',
  inheritAttrs: false,
  components: {
    FCFaqCard,
  },
  props: {
    question: {
      type: String,
      required: true,
    },
    answer: {
      type: Object as PropType<Richtext>,
      required: true,
    },
    codeId: {
      type: String,
      required: true,
    },
  },
  setup(props: IFaqCardProps) {
    const { renderRichText } = useStoryblok();

    return {
      faq: {
        question: props.question,
        answer: renderRichText(props.answer).value,
      },
    };
  },
});
